<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack()"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">
                <span v-if="isEditing">Edit Radio</span>
                <span v-else>Create Radio</span>
            </h1>
        </header>
        <section class="module__body">
            <h1
                data-test-id="page-title"
                :style="`background-image: url(${radioType.image});`"
            >
                {{ radioType.label }}
            </h1>
            <form
                class="relay-form"
                @submit.prevent="handleFormSubmit"
            >
                <radio-serial-number-field
                    id="radio-serial-textbox"
                    v-model="serial_number"
                    label="Radio Serial #"
                    data-test-id-prefix="radio-serial"
                    :disabled="isEditing"
                    :radio-type="radioType"
                    :required="true"
                />
                <div class="form-group">
                    <label
                        for="asset-number"
                        data-test-id="asset-number-title"
                        >Customer Asset #</label
                    >
                    <input
                        id="asset-number"
                        v-model="asset_number"
                        data-test-id="radio-asset-number"
                        maxlength="191"
                        minlength="3"
                        type="text"
                    />
                </div>

                <div class="form-group">
                    <label
                        for="radio-description-textbox"
                        data-test-id="radio-description-title"
                        >Description</label
                    >
                    <textarea
                        id="radio-description-textbox"
                        v-model="description"
                        class="short"
                        data-test-id="radio-description-textbox"
                        maxlength="191"
                    />
                </div>

                <form-errors :response="errorResponse" />

                <div class="form-group form-controls">
                    <button
                        type="button"
                        class="btn btn-primary"
                        :class="{ active: isSubmitted }"
                        data-test-id="submit-button"
                        :disabled="isSubmitted"
                        @click.prevent="handleFormSubmit"
                    >
                        <div v-if="isEditing">Update</div>
                        <div v-else>Create</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import radioTypes, { byValue } from '@/constants/radio-types.js'
import RadioSerialNumberField from '@/components/RadioSerialNumberField.vue'
import hasBackButton from '@/mixins/hasBackButton'
import canToast from '@/mixins/canToast'

export default {
    name: 'CreateEditAssetRadio',
    components: { RadioSerialNumberField, FormErrors },
    mixins: [needsOrganizationSlug, hasBackButton, canToast],
    data() {
        return {
            assetId: this.$route.params.assetId ?? null,
            radioType: this.$route.query.type ? byValue(this.$route.query.type) : radioTypes.PRO_X2,
            serial_number: null,
            asset_number: null,
            description: null,
            isSubmitted: false,
            isLoading: false,
            errorResponse: null,
        }
    },
    computed: {
        isEditing() {
            return this.assetId !== null
        },
    },
    mounted() {
        if (this.isEditing) {
            this.isLoading = true
            this.$http
                .get(`${this.organizationSlug}/assets/radios/${this.assetId}`)
                .then(({ data }) => {
                    this.radioType = byValue(data.type)
                    this.serial_number = data.serial_number
                    this.asset_number = data.asset_number
                    this.description = data.description
                })
                .then(() => {
                    this.isLoading = false
                })
        }
    },
    methods: {
        handleFormSubmit() {
            let url
            let method
            let data
            let verb
            if (this.isEditing) {
                url = `/${this.organizationSlug}/assets/radios/${this.assetId}`
                method = 'put'
                verb = 'updated'
                data = {
                    asset_number: this.asset_number,
                    description: this.description,
                }
            } else {
                url = `/${this.organizationSlug}/assets/radios`
                method = 'post'
                verb = 'created'
                data = {
                    type: this.radioType.type,
                    serial_number: this.serial_number,
                    asset_number: this.asset_number,
                    description: this.description,
                }
            }

            this.isSubmitted = true
            this.$http[method](url, data)
                .then(() => {
                    this.isSubmitted = false
                    this.errorResponse = null
                    this.toast(`Radio successfully ${verb}!`)
                    this.$router.go(-1)
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.isSubmitted = false
                })
        },
    },
}
</script>

<style scoped lang="scss">
.module__body {
    h1 {
        background-position: left;
        background-repeat: no-repeat;
        background-size: 30px;
        padding-left: 30px;
    }
}
</style>
